export default __webpack_public_path__ + "static/media/potts3.7509cc5b.png";